<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- // eslint-disable-next-line @angular-eslint/template/click-events-have-key-events -->
<div
  class="theme-options-panel-overlay"
  #overlay
  (click)="closeBar()"
  [fxHide]="barClosed"
  [@fadeInOut]="!barClosed"
  tabindex="0"
  
></div>
<div
  #panel
  class="theme-options-panel mat-card mat-elevation-z8"
>
  <button
    mat-icon-button
    class="close-button"
    (click)="closeBar()"
  >
    <mat-icon>close</mat-icon>
  </button>
  <div
    class="theme-options-panel-inner"
    fxLayout="column"
  >
    <h3>Themes:</h3>
    <mat-radio-group
      (change)="updateLayoutTheme($event.value)"
      [value]="(appThemeConfig$ | async).layout.theme"
      fxLayout="row"
    >
      <mat-radio-button
        *ngFor="let item of (themes | entries)"
        class="mxa"
        [value]="item[0]"
      >{{item[1].name}}</mat-radio-button>
    </mat-radio-group>
    <h3 class="mt24">Font Size:</h3>
    <mat-slider
      class="w100p"
      [max]="100"
      [min]="0"
    >
      <input matSliderThumb>
    </mat-slider>
    <mat-divider></mat-divider>
    <h3 class="mt24">Navigation:</h3>
    <mat-radio-group
      (change)="updateLayoutNavigation($event.value)"
      [value]="(navLayoutConfig$ | async).expected"
      fxLayout="row"
    >
      <mat-radio-button
        class="mxa"
        value="top"
      >Top</mat-radio-button>
      <mat-radio-button
        class="mxa"
        value="left"
      >Left</mat-radio-button>
      <mat-radio-button
        class="mxa"
        value="right"
      >Right</mat-radio-button>
      <mat-radio-button
        class="mxa"
        value="none"
      >None</mat-radio-button>
    </mat-radio-group>
    <h3 class="mt24">Toolbar:</h3>
    <mat-radio-group
      (change)="updateLayoutToolbar($event.value)"
      [value]="(appThemeConfig$ | async).layout.toolbar"
      fxLayout="row"
    >
      <mat-radio-button
        class="mxa"
        value="below"
      >Below</mat-radio-button>
      <mat-radio-button
        class="mxa"
        value="above"
      >Above</mat-radio-button>
      <mat-radio-button
        class="mxa"
        value="none"
      >None</mat-radio-button>
    </mat-radio-group>
    <h3 class="mt24">Footer:</h3>
    <mat-radio-group
      (change)="updateLayoutFooter($event.value)"
      [value]="(appThemeConfig$ | async).layout.footer"
      fxLayout="row"
    >
      <mat-radio-button
        class="mxa"
        value="below"
      >Below</mat-radio-button>
      <mat-radio-button
        class="mxa"
        value="above"
      >Above</mat-radio-button>
      <mat-radio-button
        class="mxa"
        value="none"
      >None</mat-radio-button>
    </mat-radio-group>
    <mat-divider></mat-divider>
    <h3 class="mt24">Layout Mode:</h3>
    <mat-radio-group
      (change)="updateLayoutMode($event.value)"
      [value]="(appThemeConfig$ | async).layout.mode"
      fxLayout="row"
    >
      <mat-radio-button
        class="mxa"
        value="boxed"
      >Boxed</mat-radio-button>
      <mat-radio-button
        class="mxa"
        value="fullwidth"
      >Fullwidth</mat-radio-button>
    </mat-radio-group>
    <mat-divider></mat-divider>
    <h3>Colors:</h3>
    <div
      class="colors"
      fxLayout="column"
      fxLayoutGap="8px"
    >
      <div
        fxFlex
        fxLayout="row"
        fxLayoutAlign="space-between center"
      >
        <div>Toolbar Color</div>
        <app-material-color-picker
          (selectedClassChange)="updateColorClassesToolbar($event)"
          [selectedClass]="(appThemeConfig$ | async).colorClasses.toolbar"
        ></app-material-color-picker>
      </div>
      <div
        fxFlex
        fxLayout="row"
        fxLayoutAlign="space-between center"
      >
        <div>Navigation Bar Color</div>
        <app-material-color-picker
          (selectedClassChange)="updateColorClassesNavbar($event)"
          [selectedClass]="(appThemeConfig$ | async).colorClasses.navbar"
        ></app-material-color-picker>
      </div>
      <div
        fxFlex
        fxLayout="row"
        fxLayoutAlign="space-between center"
      >
        <div>Footer Color</div>
        <app-material-color-picker
          (selectedClassChange)="updateColorClassesFooter($event)"
          [selectedClass]="(appThemeConfig$ | async).colorClasses.footer"
        ></app-material-color-picker>
      </div>
    </div>
    <mat-divider></mat-divider>
    <button
      mat-raised-button
      color="warn"
      (click)="reset()"
    >Reset All</button>
  </div>
</div>
